// extracted by mini-css-extract-plugin
export default {"wrapper":"template_wrapper__IHI55","slider":"template_slider__goD72","content":"template_content__Ipk8b"};